import PropTypes from 'prop-types';
import React from 'react';
import { IF } from 'lidya-common-components';
import { Link } from 'gatsby';
import { Trans } from 'gatsby-plugin-react-i18next';
import { useGlobalData } from '../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import landingPageConfig from '../../landingPages/config';

export const hasAcceptablePath = (pathname) => {
  const configIsValid = Array.isArray(landingPageConfig);
  if (configIsValid && landingPageConfig.includes(pathname)) return true;
  return !!pathname.match(/\/[a-z]{2}\/[a-z]{2}\//g);
};

export const buildLink = ({ pathname, country, language }) => {
  if (!country || !language) return pathname;
  const nPathName = hasAcceptablePath(pathname)
    ? pathname.replace(/\/[a-z]{2}\/[a-z]{2}\//g, `/${country}/${language}/`)
    : `/${country}/${language}/${pathname}/`;
  return nPathName;
};

export function ContextLink({
  to, children, country, language, label, exact, className, activeClassName, partiallyActive, ariaLabel, id, target,
}) {
  const { country: currentCountry, language: currentLanguage } = useGlobalData();
  const nCountry = country || currentCountry;
  const nLanguage = language || currentLanguage;
  const nLink = buildLink({
    pathname: to,
    country: nCountry,
    language: nLanguage,
  });
  return (
    <IF
      condition={!target}
      Else={() => (
        <a
          id={id}
          className={className}
          href={nLink}
          aria-label={ariaLabel}
          title={ariaLabel}
          target={target}
        >
          <Trans>{children || label}</Trans>
        </a>
      )}
    >
      <Link
        exact={exact.toString()}
        className={className}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        id={id}
        to={nLink}
        aria-label={ariaLabel}
      >
        <Trans>{children || label}</Trans>
      </Link>
    </IF>
  );
}

ContextLink.propTypes = {
  activeClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.elementType,
    PropTypes.shape([]),
  ]),
  className: PropTypes.string,
  country: PropTypes.string,
  exact: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  language: PropTypes.string,
  partiallyActive: PropTypes.bool,
  to: PropTypes.string,
  ariaLabel: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
};

ContextLink.defaultProps = {
  children: '',
  label: '',
  country: undefined,
  language: undefined,
  to: '',
  activeClassName: undefined,
  className: undefined,
  exact: false,
  partiallyActive: false,
  ariaLabel: '',
  target: undefined,
};

export default ContextLink;
